import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const eocGlobalMaintenanceRoute: InvariantJiraRoute = {
	name: 'eoc-global-maintenance',
	path: '/jira/settings/products/ops/maintenance',
	exact: true,
};
